import { render, staticRenderFns } from "./mc-submodul.vue?vue&type=template&id=05eb871b&scoped=true"
import script from "./mc-submodul.vue?vue&type=script&lang=js"
export * from "./mc-submodul.vue?vue&type=script&lang=js"
import style0 from "./mc-submodul.vue?vue&type=style&index=0&id=05eb871b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eb871b",
  null
  
)

export default component.exports